import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error non-ts module import
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Popover, PopoverBody, PopoverCloseButton, PopoverFooter, PopoverHeader } from 'foundations-components/transitional/components/Popover';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getHasMABAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getHasSeenAiAbTestShepherd } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
// @ts-expect-error non-ts module import
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
// @ts-expect-error non-ts module import
import { HAS_SEEN_AI_AB_TEST_SHEPHERD } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
// @ts-expect-error non-ts module import
import { getIsAnyTestRunning } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getIsGenerativeAiEnabled } from 'ContentEditorUI/redux/selectors/contentAssistantSelectors';
import { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getIsUngatedForAiAbLandingPages } from '../redux/selectors/authSelectors';
import { getIsPersonalized } from '../redux/selectors/pageContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AI_AB_TEST_KB_URL = 'https://knowledge.hubspot.com/website-and-landing-pages/create-a-b-tests-for-pages-with-ai';
export const AiAbTestShepherd = () => {
  var _testSidebarButton$cu;
  const testSidebarButton = useRef(null);
  const dispatch = useDispatch();
  const isLandingPage = useSelector(getIsLandingPage);
  const isUngatedForAiAbLandingPages = useSelector(getIsUngatedForAiAbLandingPages);
  const hasSeenAiAbTestShepherd = useSelector(getHasSeenAiAbTestShepherd);
  const isGenerativeAiEnabled = useSelector(getIsGenerativeAiEnabled);
  const isAnyTestRunning = useSelector(getIsAnyTestRunning);
  const hasMABAccess = useSelector(getHasMABAccess);
  const isSeleniumRunning = window.SELENIUM_IS_RUNNING;
  const isPersonalized = useSelector(getIsPersonalized);
  const shouldRenderShepherd = !isSeleniumRunning && isLandingPage && isUngatedForAiAbLandingPages && isGenerativeAiEnabled && !isAnyTestRunning && hasMABAccess && !hasSeenAiAbTestShepherd && !isPersonalized;
  useEffect(() => {
    testSidebarButton.current = document.querySelector('[data-sidebar-button-id="tools"]');
  }, []);
  return /*#__PURE__*/_jsx(Popover, {
    open: shouldRenderShepherd,
    content: /*#__PURE__*/_jsxs(View, {
      inlineSize: "350px",
      blockSize: "190px",
      children: [/*#__PURE__*/_jsx(PopoverHeader, {
        padding: "0",
        children: /*#__PURE__*/_jsxs(Flex, {
          backgroundColor: "fill-accent-purple-default",
          inlineSize: "100%",
          blockSize: "100%",
          justifyContent: "space-between",
          paddingInline: "600",
          paddingBlock: "400",
          children: [/*#__PURE__*/_jsx(Text, {
            color: "text-core-on-fill-default",
            typography: "heading-300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "aiAbTestFlow.shepherd.title"
            })
          }), /*#__PURE__*/_jsx(PopoverCloseButton, {
            color: "icon-core-on-fill-default",
            onClick: () => dispatch(setSuperstoreUserSetting(HAS_SEEN_AI_AB_TEST_SHEPHERD, true)),
            size: "lg"
          })]
        })
      }), /*#__PURE__*/_jsx(PopoverBody, {
        paddingBlockStart: "400",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "aiAbTestFlow.shepherd.message"
          })
        })
      }), /*#__PURE__*/_jsx(PopoverFooter, {
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: () => dispatch(setSuperstoreUserSetting(HAS_SEEN_AI_AB_TEST_SHEPHERD, true)),
            size: "sm",
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "aiAbTestFlow.shepherd.close"
            })
          }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
            onClick: () => dispatch(setSuperstoreUserSetting(HAS_SEEN_AI_AB_TEST_SHEPHERD, true)),
            use: "secondary",
            url: AI_AB_TEST_KB_URL,
            size: "sm",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "aiAbTestFlow.shepherd.learnMore"
            })
          })]
        })
      })]
    }),
    target: (_testSidebarButton$cu = testSidebarButton.current) !== null && _testSidebarButton$cu !== void 0 ? _testSidebarButton$cu : undefined
  });
};